(function () {
  var MOBILE_QUERY = '(max-width: 589px)';

  function fallbackHeaderOffset() {
    return window.matchMedia(MOBILE_QUERY).matches ? 84 : 116;
  }

  function getHeaderOffset() {
    var group = document.querySelector('.shopify-section-group-header-group');
    var header = document.getElementById('SiteHeader');
    var height = 0;

    if (group) {
      height = Math.round(group.getBoundingClientRect().height);
    } else if (header) {
      var announcement = document.querySelector('.announcement');
      if (announcement && announcement.offsetParent !== null) {
        height += Math.round(announcement.getBoundingClientRect().height);
      }
      height += Math.round(header.getBoundingClientRect().height);
    }

    return (height || fallbackHeaderOffset()) + 'px';
  }

  function syncHeaderOffset() {
    var offset = getHeaderOffset();
    document.documentElement.style.setProperty('--site-header-offset', offset);
    document.documentElement.style.setProperty('--byob-shop-header-offset', offset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncHeaderOffset);
  } else {
    syncHeaderOffset();
  }

  window.addEventListener('resize', syncHeaderOffset);
  window.addEventListener('load', syncHeaderOffset);
})();
